import { render, staticRenderFns } from "./BankRemitRemark.vue?vue&type=template&id=2fcb2d6a&scoped=true&"
import script from "./BankRemitRemark.vue?vue&type=script&lang=ts&"
export * from "./BankRemitRemark.vue?vue&type=script&lang=ts&"
import style0 from "./BankRemitRemark.vue?vue&type=style&index=0&id=2fcb2d6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcb2d6a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCol,VRow,VSheet})
